import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import PropTypes from 'prop-types';
import { HelpOutlineOutlined } from '@mui/icons-material';
import Tooltip from '../Tooltip';
const Help = ({ title, text }) => {
    return (_jsx(Tooltip, { title: title, text: text, children: _jsx(HelpOutlineOutlined, { sx: { verticalAlign: 'middle', cursor: 'help' }, fontSize: 'small', color: 'info' }) }));
};
Help.propTypes = {
    text: PropTypes.string.isRequired,
};
export default memo(Help);
